"use strict";

(function () {
  'use strict';

  angular.module('lr.Auth').directive('lrAuth', ['$rootScope', '$location', 'authEvents', 'User', '$timeout', 'authErrors', '$cookieStore', 'SupportedProviders', function ($rootScope, $location, authEvents, User, $timeout, authErrors, $cookieStore, SupportedProviders) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {},
      controller: function controller($scope, $rootScope, $window, $element, $cookieStore, SupportedProviders, authNames) {
        var $body = $('body');
        var providers = SupportedProviders;

        function _init() {
          $scope.user = {};
          $scope.server = {};
          $scope.error = {};
          $scope.isLoading = false;
        } //this is here until angular material fixes its broken validation directive junk


        function _testFormAttribute(attribute) {
          if ($scope.user[attribute] && $scope.user[attribute].toString().length > 0) {
            $scope.authForm[attribute].$setValidity(attribute, true);
          } else {
            $scope.authForm[attribute].$setValidity(attribute, false);
            $scope.error[attribute] = true;
            $scope.error.msg = authErrors[attribute];
          }
        }

        function _pointCentralSuccess(data) {
          $window.sessionStorage.point = JSON.stringify(data);
        }

        function _emptyErrors() {
          $scope.error = {};
        }

        function _emptyUser() {
          $scope.user = {};
        }

        function _authPointCentral() {
          User.authPointCentral().then(function (data) {
            _pointCentralSuccess(data.data);
          })["catch"](function (data) {
            //fail silently
            //attempt to auth when viewing details of property
            console.log(data);
          });
        }

        $scope.success = _success;

        function _success(jsonData) {
          //success
          $timeout(function () {
            _toggleLoading();

            _emptyErrors();

            _emptyUser();

            $window.sessionStorage.token = jsonData;
            var token = User.getToken();

            if (!token.RTMAccess) {
              return $rootScope.$broadcast(authEvents.login, true);
            }

            if (User.isProviderSupported('PointCentral')) {
              _authPointCentral();
            }

            return $rootScope.$broadcast(authEvents.success, jsonData);
          }, 300);
        }

        function _fail(msg) {
          //fail
          $timeout(function () {
            _disableLoading();

            $scope.server.msg = msg;
            $scope.user.password = '';
          }, 300);
        }

        function _toggleLoading() {
          $scope.isLoading = !$scope.isLoading;
        }

        function _disableLoading() {
          $scope.isLoading = false;
        }

        $scope.loginShow = function () {
          $scope.isLoading = false;
          $body.addClass('overflow-hidden');
          $element.removeClass('fadeOut lr-animated').show().addClass('fadeIn lr-animated');
        };

        $scope.loginHide = function () {
          $element.addClass('hidden').removeClass('fadeIn lr-animated').addClass('fadeOut lr-animated');
          $timeout(function () {
            $body.removeClass('overflow-hidden');

            _toggleLoading();

            $element.removeClass('hidden').hide();
          }, 500);
        };

        $scope.authFormSignIn = function () {
          _toggleLoading();

          _testFormAttribute('password');

          _testFormAttribute('username');

          _testFormAttribute('securityID');

          $scope.server = {};

          if ($scope.authForm.$valid) {
            $scope.error = {};
            User.login($scope.user).then(function (data) {
              var responseData = data.data;

              _success(responseData);
            })["catch"](function (data) {
              if (data.status === 401) {
                _fail(authErrors.forbidden);
              } else if (data.status === 403) {
                _fail(authErrors.unauthorized);
              } else if (data.status === 412) {
                _fail(authErrors.noAccess);
              } else {
                _fail(authErrors.system);
              }
            });
          } else {
            _toggleLoading();
          }
        };

        if ($cookieStore.get('__lrAuth')) {
          $window.sessionStorage.token = $cookieStore.get('__lrAuth');
          $cookieStore.remove('__lrAuth');
        }

        var token = User.getToken();

        if (User.isAuthenticated() && token) {
          $rootScope.$broadcast(authEvents.success, token);
          $scope.loginHide();
        } else {
          $rootScope.$broadcast(authEvents.login, true);
          $scope.loginShow();
        }

        _init();
      },
      link: function link(scope) {
        $rootScope.$on(authEvents.login, function () {
          // try to go and get the oAuth cookie
          var oAuthCookieData = User.getOAuthCookie(); // check if the oAuth cookie data exists

          if (oAuthCookieData && oAuthCookieData.OAuthAccessToken && $location.path() !== '/login') {
            // try and login with just the oauth cookie
            User.oAuthLogin(oAuthCookieData.OAuthAccessToken).then(function (response) {
              if (response.data && response.status === 200) {
                // send the jwt to the auth link success func like the normal login handles
                scope.success(response.data);
              } else {
                // show the login screen
                User.clearSession();
                setTimeout(function () {
                  scope.loginShow();
                }, 0);
              }
            })["catch"](function (ex) {
              User.clearSession();
              setTimeout(function () {
                scope.loginShow();
              }, 0);
            });
          } else {
            // show the login screen
            User.clearSession();
            setTimeout(function () {
              scope.loginShow();
            }, 1000);
          }
        });
        $rootScope.$on(authEvents.logout, function () {
          User.logout();
        });
        $rootScope.$on(authEvents.success, function () {
          scope.loginHide();
        });
      },
      templateUrl: 'app/auth/lr-auth.html'
    };
  }]);
})();